import { render } from "./Header.vue?vue&type=template&id=65ed4a02&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=65ed4a02&lang=css"
import "./Header.vue?vue&type=style&index=1&id=65ed4a02&scoped=scoped&lang=css"

import exportComponent from "E:\\Work\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ed4a02"]])

export default __exports__